import { browserName, browserVersion } from "react-device-detect";

const userBrowserName = browserName
const userBrowserVersion = browserVersion
const appPlatform = 'WEB'
const appVersion = '1.0.0'
const firebaseConfig = {
    apiKey: "AIzaSyBUScMNfta59ibBwV9OpRj_KVo8I4L3Z1Q",
    authDomain: "easypay-android.firebaseapp.com",
    databaseURL: "https://easypay-android.firebaseio.com",
    projectId: "easypay-android",
    storageBucket: "easypay-android.appspot.com",
    messagingSenderId: "500504348759",
    appId: "1:500504348759:web:a991cce85386d18375bb12",
    measurementId: "G-4DVZ1KV2YF"
  };

const apiUrls = {
    secondaryUserAuth: 'https://mobileapi.easypay.al/EasyPay/UserAuthV7/UserAuthService.svc/restful/',
    secondaryServices: 'https://mobileapi.easypay.al/EasyPay/EasyPayServicesV5/EasyPayServices.svc/restful/',
    secondaryP2P: 'https://mobileapi.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/',
    primaryUserAuth: 'https://mobileapi2.easypay.al/EasyPay/UserAuthV7/UserAuthService.svc/restful/',
    primaryServices : 'https://mobileapi2.easypay.al/EasyPay/EasyPayServicesV5/EasyPayServices.svc/restful/',
    primaryP2P: 'https://mobileapi2.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/'
  }

/*Primary:
    secondaryUserAuth: 'https://mobileapi.easypay.al/EasyPay/UserAuthV5/UserAuthService.svc/restful/',
    secondaryServices: 'https://mobileapi.easypay.al/EasyPay/EasyPayServicesV5/EasyPayServices.svc/restful/',
    secondaryP2P: 'https://mobileapi.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/',
    primaryUserAuth: 'https://mobileapi2.easypay.al/EasyPay/UserAuthV5/UserAuthService.svc/restful/',
    primaryServices : 'https://mobileapi2.easypay.al/EasyPay/EasyPayServicesV5/EasyPayServices.svc/restful/',
    primaryP2P: 'https://mobileapi2.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/'
*/
//testing:
// secondaryUserAuth: "https://mobileapi.easypay.al/EasyPay/UserAuthInternal/UserAuthService.svc/restful/",
// secondaryServices: 'https://mobileapi.easypay.al/EasyPay/EasyPayServicesInternal/EasyPayServices.svc/restful',
// secondaryP2P: 'https://mobileapi.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/',
// primaryUserAuth: "https://mobileapi.easypay.al/EasyPay/UserAuthInternal/UserAuthService.svc/restful/", //'
// primaryServices : 'https://mobileapi.easypay.al/EasyPay/EasyPayServicesInternal/EasyPayServices.svc/restful',//
// primaryP2P: 'https://mobileapi2.easypay.al/emoneyServiceV2/EmoneyService.svc/restful/'
export default { apiUrls,firebaseConfig, appVersion, userBrowserName, userBrowserVersion, appPlatform }